import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';

import { ICONS } from '@core/services/icons/icons.service';
import { selectDataspaceModel } from '@core/store/dataspace/dataspace.selectors';
import * as PlanSelectors from '@core/store/plan/plan.selectors';

import { planOverviewCommands } from './plan-overview-link';

@Component({
  selector: 'app-plan-info-overview-link',
  imports: [RouterLink, TranslatePipe],
  templateUrl: './plan-info-overview-link.component.html',
  styles: ``
})
export class PlanInfoOverviewLinkComponent {
  protected readonly ICONS = ICONS;
  private readonly plan = inject(Store).selectSignal(PlanSelectors.selectPlan);
  private readonly dataspace = inject(Store).selectSignal(selectDataspaceModel);

  protected readonly commands = computed(() =>
    planOverviewCommands(
      this.dataspace()?.id,
      this.plan()?.planningSpace.id,
      this.plan()?.id
    )
  );
}
